(() => {
  if (window.TheniyaOffers) return;
  const root = window.Shopify?.routes?.root || '/';
  const request = async (path, body) => {
    const response = await fetch(root + path, body === undefined
      ? { headers: { Accept: 'application/json' } }
      : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || result.message || window.cartStrings?.error || 'Something went wrong');
    return result;
  };
  let queue = Promise.resolve();
  const serial = task => { queue = queue.catch(() => {}).then(task); return queue; };

  // ---------- Cart: apply the best volume code automatically ----------
  const readOffers = () => {
    try { return JSON.parse(document.getElementById('TheniyaOffersData')?.textContent || '[]'); } catch { return []; }
  };
  const live = offer => {
    const now = Date.now() / 1000;
    return (!offer.start || now >= offer.start) && (!offer.end || now < offer.end);
  };
  const qualifying = (cart, offer) => cart.items
    .filter(item => offer.products.includes(item.product_id) && !item.properties?._theniya_gift)
    .reduce((total, item) => total + item.quantity, 0);
  const bestOffer = (cart, offers) => {
    let pick = null, saving = 0;
    for (const offer of offers) {
      const count = qualifying(cart, offer);
      if (count < offer.min) continue;
      const value = count * offer.each;
      if (value > saving) { saving = value; pick = offer; }
    }
    return pick;
  };
  const sameCodes = (a, b) => a.length === b.length && a.every(code => b.some(other => other.toUpperCase() === code.toUpperCase()));

  const renderDrawer = (drawer, state, open) => {
    if (open) { drawer.classList.toggle('is-empty', state.item_count === 0); drawer.renderContents(state); return; }
    drawer.getSectionsToRender().forEach(section => {
      const target = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      const html = state.sections?.[section.id];
      if (target && html) target.innerHTML = drawer.getSectionInnerHTML(html, section.selector);
    });
    drawer.classList.toggle('is-empty', state.item_count === 0);
  };

  async function reconcile({ forceOpen = false } = {}) {
    const offers = readOffers();
    const drawer = document.querySelector('cart-drawer');
    const cart = await request('cart.js');
    const current = (cart.discount_codes || []).map(code => code.code).filter(Boolean);
    let wanted = current;
    if (offers.length) {
      const managed = offers.map(offer => offer.code.toUpperCase());
      const keep = current.filter(code => !managed.includes(code.toUpperCase()));
      const pick = bestOffer(cart, offers.filter(live));
      wanted = pick ? [...keep, pick.code] : keep;
    }
    const changed = !sameCodes(wanted, current);
    if (!changed && !forceOpen) return;
    const body = changed ? { discount: wanted.join(',') } : {};
    if (drawer) { body.sections = drawer.getSectionsToRender().map(section => section.id); body.sections_url = location.pathname; }
    const state = await request('cart/update.js', body);
    if (drawer) renderDrawer(drawer, state, forceOpen || drawer.classList.contains('active'));
    else if (changed && /\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'theniya-offers', cartData: state });
  }

  const start = () => {
    if (typeof subscribe === 'function') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
        if (event?.source === 'theniya-offers') return;
        serial(() => reconcile()).catch(error => console.error(error));
      });
    }
    serial(() => reconcile()).catch(error => console.error(error));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  // ---------- Product page: collapse long descriptions behind "Learn more" ----------
  const collapseDescription = () => {
    const box = document.querySelector('.product-info-column .product-description');
    if (!box || box.dataset.collapsible) return;
    const meaningful = el => el.textContent.trim() !== '' || el.querySelector('img, video, iframe');
    let blocks = [...box.children].filter(meaningful);
    if (blocks.length === 1 && blocks[0].children.length > 2) blocks = [...blocks[0].children].filter(meaningful);
    if (blocks.length <= 2) return;
    let visible = 2;
    // Don't end the preview on a lead-in heading like "Why You'll Love These Files:".
    if (blocks[visible - 1].textContent.trim().endsWith(':')) visible -= 1;
    const hidden = blocks.slice(visible);
    box.dataset.collapsible = 'true';
    hidden.forEach(el => { el.hidden = true; });
    if (!document.getElementById('theniya-learn-more-style')) {
      const style = document.createElement('style');
      style.id = 'theniya-learn-more-style';
      style.textContent = '.theniya-learn-more{display:inline-block;margin:4px 0 0;padding:0;border:0;background:none;font:inherit;font-size:14px;font-weight:600;color:inherit;text-decoration:underline;text-underline-offset:3px;cursor:pointer}.product-description [hidden]{display:none!important}';
      document.head.append(style);
    }
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'theniya-learn-more';
    button.textContent = 'Learn more';
    button.setAttribute('aria-expanded', 'false');
    button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') !== 'true';
      hidden.forEach(el => { el.hidden = !open; });
      button.setAttribute('aria-expanded', String(open));
      button.textContent = open ? 'Show less' : 'Learn more';
    });
    box.append(button);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', collapseDescription); else collapseDescription();

  // ---------- Product page: tier selector ----------
  const money = cents => '$' + (cents / 100).toFixed(2);

  class TheniyaOfferTiers extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById('product-form');
      // Rendered inside the cart drawer (re-rendered on every cart update). The first copy moves
      // itself above the product form; later copies from drawer re-renders remove themselves.
      if (!this.dataset.placed) {
        const placed = document.querySelector('theniya-offer-tiers[data-placed]');
        if (!this.form || (placed && placed !== this)) { this.remove(); return; }
        this.dataset.placed = 'true';
        this.form.before(this);
        return;
      }
      if (this.ready) return;
      this.ready = true;
      this.price = Number(this.dataset.price);
      this.button = this.form?.querySelector('[type="submit"]');
      this.buttonHTML = this.button?.innerHTML;
      this.quantityBox = this.form?.querySelector('.product-quantity');
      this.quantityInput = this.form?.querySelector('input[name="quantity"]');
      this.slots = this.querySelector('[data-slots]');
      this.template = this.querySelector('[data-slot-template]');
      // Radios are named only once placed, so drawer re-renders (which briefly insert another
      // copy) can't uncheck this group.
      const group = 'theniya-tier-' + Math.random().toString(36).slice(2);
      this.querySelectorAll('[data-tier-radio]').forEach(radio => { radio.name = group; });
      this.addEventListener('change', event => {
        if (event.target.matches('[data-tier-radio]')) this.select(Number(event.target.value));
      });
      this.onSubmit = event => this.submit(event);
      // Window capture runs before the theme's document-level cart/add handler.
      window.addEventListener('submit', this.onSubmit, true);
      this.select(1);
    }
    get tier() { return this.quantity || 1; }
    select(quantity) {
      this.quantity = quantity;
      this.querySelectorAll('.theniya-tier').forEach(label => {
        const radio = label.querySelector('[data-tier-radio]');
        radio.checked = Number(radio.value) === quantity;
        label.classList.toggle('is-selected', radio.checked);
      });
      const multi = quantity > 1;
      this.querySelector('[data-scents]').hidden = !multi;
      if (this.quantityBox) this.quantityBox.hidden = multi;
      if (this.quantityInput) this.quantityInput.value = 1;
      this.slots.replaceChildren();
      if (multi) {
        for (let i = 0; i < quantity; i++) {
          const select = this.template.content.firstElementChild.cloneNode(true);
          select.setAttribute('aria-label', `Scent ${i + 1} of ${quantity}`);
          const current = select.querySelector('option[data-current]:not([disabled])') || select.querySelector('option:not([disabled])');
          if (current) select.value = current.value;
          const row = document.createElement('label');
          row.className = 'theniya-tiers__slot';
          const number = document.createElement('span');
          number.className = 'theniya-tiers__slot-number';
          number.textContent = i + 1;
          row.append(number, select);
          this.slots.append(row);
        }
        const each = Number(this.querySelector(`input[value="${quantity}"]`).dataset.each);
        const total = Math.max(0, this.price - each) * quantity;
        if (this.button) this.button.textContent = `Add ${quantity} Cuticle Oils - ${money(total)}`;
      } else if (this.button) {
        this.button.innerHTML = this.buttonHTML;
      }
      this.querySelector('[data-tier-error]').textContent = '';
    }
    async submit(event) {
      if (event.target !== this.form || this.tier <= 1) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.busy) return;
      const counts = new Map();
      this.slots.querySelectorAll('select').forEach(select => counts.set(select.value, (counts.get(select.value) || 0) + 1));
      const items = [...counts].filter(([id]) => id).map(([id, quantity]) => ({ id: Number(id), quantity }));
      const error = this.querySelector('[data-tier-error]');
      error.textContent = '';
      this.busy = true;
      if (this.button) { this.button.disabled = true; this.button.setAttribute('aria-busy', 'true'); }
      try {
        await request('cart/add.js', { items });
        document.querySelector('cart-drawer')?.setActiveElement(this.button);
        await serial(() => reconcile({ forceOpen: true }));
      } catch (failure) {
        error.textContent = failure.message;
      } finally {
        this.busy = false;
        if (this.button) { this.button.disabled = false; this.button.removeAttribute('aria-busy'); }
      }
    }
  }
  customElements.define('theniya-offer-tiers', TheniyaOfferTiers);
  window.TheniyaOffers = { reconcile: () => serial(() => reconcile()) };
})();
